import * as actionTypes from './actionTypes';

export const navBarUpdate = (value) => {
  return {
    type : actionTypes.NAVBAR_UPDATE,
    value
  }
}

export const navBarClear = () => {
  return {
    type : actionTypes.NAVBAR_RESET,
  }
}
